<template>
  <input-select
      label="Items per Page:"
      error-name="items per page"
      v-bind:value="selection" v-on:input="$emit('imagePerPageChanged', $event)"
  >
    <select-option :value="5">5</select-option>
    <select-option :value="10">10</select-option>
    <select-option :value="25">25</select-option>
    <select-option :value="50">50</select-option>
    <select-option :value="100">100</select-option>
  </input-select>
</template>

<script>
import InputSelect from "../forms/InputSelect";
import SelectOption from "../forms/SelectOption";

export default {
  components: {SelectOption, InputSelect},

  props: ['value'],

  data() {
    return {
      selection: this.value,
    };
  },

  watch: {
    value(newValue) {
      this.selection = newValue;
    },
  },

  mounted() {
    this.selection = this.value;
  }
}
</script>